import { useCallback } from 'react';

import { useNavigate } from 'js/hooks/navigate';
import { getCleanUrl } from 'js/utils/url.util';

export const useGameInfo = (props) => {
    const navigate = useNavigate();
    const navigateReplaced = useNavigate({ replace: true });
    const { hideButtons, gameLaunchType, showFavoriteIcon } = props;
    const gameUrlFragment = props.seoFriendlyGameName || props.gameCode;

    return useCallback(() => {
        const { prevPath } = window.history.state?.state || {};
        const giPath = 'online-game';
        const isInGiPath = location.pathname.includes(giPath);
        const state = isInGiPath
            ? {
                prevPath,
                hideButtons,
                gameLaunchType,
                showFavoriteIcon,
                showBackButton: true
            }
            : {
                hideButtons,
                gameLaunchType,
                showFavoriteIcon,
                prevPath: getCleanUrl()
            };

        (isInGiPath ? navigateReplaced : navigate)(`/${giPath}/${gameUrlFragment}`, state);
    }, [gameLaunchType, gameUrlFragment, hideButtons, navigate, navigateReplaced, showFavoriteIcon]);
};
